export { default } from "./Page";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-processing/Page/index.js